module.exports = __webpack_public_path__ + "static/media/IE.9ad4c149.svg";